import { Container, Grid, Typography, Box, Stack } from '@mui/material';
import React from 'react';
import Title from '../components/Title';
import imgbg from '../assets/images/section3/background.png';
import { Fade } from 'react-awesome-reveal';

const Section7 = () => {
  return (
    <Box
      sx={{ textAlign: 'center', color: 'white', p: { md: 3 }, mb: 10 }}
      style={{
        background: `url(${imgbg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        opacity: 5
      }}
    >
      <Container maxWidth="xl" component={Fade}>
        <Title
          style={{
            textAlign: 'center',
            color: '#CA7729',
            fontSize: '35px',
            fontWeight: 'bold',
            letterSpacing: '0.02em',
            marginTop: '20px'
          }}
          variant="h3"
          className="sectionHeadingTitle"
        >
          Who We Are?
        </Title>
        <Grid container spacing={5} style={{ justifyContent: 'center', alignItems: 'center', p: 20 }}>
          {/* Left */}
          <Grid item xs={12} md={6}>
            <Box
              style={{
                // background: 'url(/images/homepage/cardbg.png)',
                padding: '20px',
                height: '90%',
                borderRadius: '10px',
                alignItems: 'center',
                textAlign: 'left'
                // width:'60%',
              }}
            >
              <Typography
                style={{ fontSize: '18px', color: '#000' }}
                variant="h3"
                sx={{ mt: 3, letterSpacing: '0.05em', fontWeight: '500' }}
              >
                Taral aims to set a new standard in the blockchain industry by offering solutions that address longstanding challenges L1s
                have been suffering from. <br /> It combines the best of both worlds – A proof-of-stake mechanism enabling scalability,
                lower gas fees, a rewarding validator mechanism, and a better governance model. <br /> A dual deflationary model with a
                systematic halving schedule for stable token economics and inflation control. A burn mechanism to maintain token scarcity
                and value over time. <br /> Taral Blockchain envisions to be the most decentralized blockchain, enabling real-world impact
                by addressing global challenges and driving positive social and economic change.
              </Typography>
            </Box>
          </Grid>
          {/* Right */}
          <Grid item xs={12} md={6}>
            <Stack sx={{ height: '100%' }}>
              <Box
                style={{
                  // background: 'url(/images/homepage/cardbg.png)',
                  padding: '20px',
                  height: '100%',
                  borderRadius: '10px',
                  alignItems: 'center'
                }}
              >
                {/* <img width="100%" src="/images/card/cardimg.png" alt="cardimg" /> */}
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Section7;
